
export default {
	guests: {},
	guestList: [],
}